// extracted by mini-css-extract-plugin
module.exports = {"errorWrapper":"errorWrapper-GTwFG","errorTitle":"errorTitle-wdXWC","errorText":"errorText-3zT80"};